export const CHANGE_PAGE = "CHANGE_PAGE";
export const PARAMETERIZATION_TYPE = "PARAMETERIZATION_TYPE";
export const COMPANY_NAME = "COMPANY_NAME";
export const ID_MODULE_VIDE = "ID_MODULE_VIDE";
export const ID_QUIZ_MODULE = "ID_QUIZ_MODULE";
